module.exports = __webpack_public_path__ + "static/media/img_cat.3137a61a.svg";